import { Column } from '../Grid'
import { NextImage } from '../NextImage'
import { Text } from '../Text'

export const UnavailablePsyMessage = () => (
  <>
    <Column width='40px' mr={['0', '0', '16px']} mt='8px'>
      <NextImage
        height={16}
        width={16}
        src='/static/images/alert-octagon.svg'
        alt='Ícone de alerta'
      />
    </Column>
    <Column>
      <Text textAlign='left' color='lightGray' fontSize='1rem'>
        Profissional indisponível no seu benefício corporativo
      </Text>
    </Column>
  </>
)
